import { render, staticRenderFns } from "./coachTransactions.vue?vue&type=template&id=64e64201&scoped=true"
import script from "./coachTransactions.vue?vue&type=script&lang=js"
export * from "./coachTransactions.vue?vue&type=script&lang=js"
import style0 from "./coachTransactions.vue?vue&type=style&index=0&id=64e64201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e64201",
  null
  
)

export default component.exports